
import { Encryptor, LzEncryptor } from "./Encryptor";

export const CacheManager = {

    HANDSHAKE_KEY: "uyujhfg",
    PROFILE_KEY: "omnehost.p",
    __cacheImpl__: localStorage,
    ACCESS_TOKEN_KEY: "omnehost.at",
    SESSION_TOKEN_KEY: "omnehost.st",
    __encryptorImpl__: LzEncryptor,

    setStorage(cacheImpl: Storage) {
        CacheManager.__cacheImpl__ = cacheImpl;
    },

    setEncryptor(encryptorImpl: Encryptor) {
        CacheManager.__encryptorImpl__ = encryptorImpl;
    },

    has(key: string) {
        const item = CacheManager.__cacheImpl__.getItem(key);
        return (item !== null && item !== "")
    },

    remove(key: string) {
        CacheManager.__cacheImpl__.removeItem(key);
    },

    put(key: string, value: string | number | Object) {
        const valueToStore = JSON.stringify({
            value,
            type: typeof value,
        });
        CacheManager.__cacheImpl__.setItem(key, CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.encrypt(valueToStore) : valueToStore);
    },

    get(key: string, fallback?: any) {
        if (!CacheManager.has(key)) {
            return fallback;
        }
        const cacheValue = CacheManager.__cacheImpl__.getItem(key) as string;
        const valueToStore = JSON.parse(CacheManager.__encryptorImpl__ ? CacheManager.__encryptorImpl__.decrypt(cacheValue) : cacheValue);
        return valueToStore.value;
    },

    clear() {
        CacheManager.__cacheImpl__.clear();
    }

}